import React from 'react';
import '../styles/DownloadFileExample.css';

const downloadUrl = `${process.env.PUBLIC_URL}/downloads/practice-sample.txt`;

const DownloadFileExample = () => {
  return (
    <div className="download-file-page" id="download-file-page">
      <section className="download-file-section" id="download-file-section">
        <div className="download-file-card">
          <h3 className="download-file-section-title">Download File</h3>
          <p className="download-file-behavior">
            Configure the browser download directory, then click Download Sample File and
            verify the file is saved in your custom folder.
          </p>

          <div className="download-file-action-row">
            <a
              href={downloadUrl}
              download="practice-sample.txt"
              className="download-file-button"
              id="download-sample-file"
            >
              Download Sample File
            </a>

            <div className="download-file-result-area" id="download-folder-info">
              <p className="download-file-info" id="download-file-name">
                File name: practice-sample.txt
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DownloadFileExample;
